module.exports = __webpack_public_path__ + "static/media/repate.23c668b0.png";